import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import DropdownTest from "../Create-Investment/ndrop";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import { svgLogoBase64 } from "../../Constants/config";
import {
  setInvestmentIDRedux,
  setTabSelfRedux,
} from "../../Redux/store/inspecie-transfer";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
const MandateDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const [sortkey, setSortKey] = useState("minimum_investment");
  const [showRecords, setShowRecords] = useState(10);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenReport, setIsOpenReport] = useState(false);
  const [selected, setSelected] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const accountRef = useRef();
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const DownloadDocRef = useRef();
  const [isHidden, setIsHidden] = useState(false);
  const [pdfData, setPdfData] = useState([]);
  const buttonRefs = useRef({});
  const favouriteRef = useRef();
  const [IsfavouriteOpen, setIsfavouriteOpen] = useState(false);
  const [selectedFavourite, setSelectedFavourite] = useState("all");
  const [transactionHistoryData, setTransactionHistoryData] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const DownloadRef = useRef();
  const [selectedDates, setSelectedDates] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const DateCalendarRef = useRef();
  const [searchQueryStrategies, setSearchQueryStrategies] = useState("");
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const Allfavourites = [
    { value: "all", label: "ALL" },
    { value: "fav", label: "Favorite" },
    { value: "non-fav", label: "Non-Favorite" },
  ];
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];
  const AllRiskProfile = [];
  AllRiskProfile.push({
    value: "",
    label: "ALL",
  });
  AllRiskProfile.push({
    value: "medium",
    label: "Medium",
  });
  AllRiskProfile.push({
    value: "high",
    label: "High",
  });
  AllRiskProfile.push({
    value: "low",
    label: "Low",
  });
  const quickFilters = [
    { label: "This Week", value: "this_week" },
    { label: "Last Week", value: "last_week" },
    { label: "This Month", value: "this_month" },
    { label: "This Year", value: "this_year" },
    { label: "Last Year", value: "last_year" },
    { label: "Custom", value: "custom" },
    { label: "All Time", value: "" },
  ];
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
    setCurrentPage(1);
  };
  const GetCSV = async () => {
    const token = localStorage.getItem("jwtToken");

    const apiUrl = `${BASE_URL}/v1/investment-portfolio/download-csv`;
    const headers = {
      "Content-Type": "text/csv",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(apiUrl, {
      method: "GET",
      headers,
    });

    return response.blob();
  };
  const formatDateForFilter = (dateString) => {
    const date = new Date(dateString);

    // Extract year, month, and date
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 since months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Format as yyyy-dd-mm
  };
  const downloadExcelReportTransaction = async () => {
    const token = localStorage.getItem("jwtToken");
    let apiUrl = "";

    if (selectedDates.length == 2) {
      apiUrl = `${BASE_URL}/v1/merchant/dashboard/my-investment/transactions/export/excel?page=${currentPage}&size=1000&search=${searchQuery}&start_date=${formatDateForFilter(
        selectedDates[0]
      )}&end_date=${formatDateForFilter(selectedDates[1])}`;
    } else {
      apiUrl = `${BASE_URL}/v1/merchant/dashboard/my-investment/transactions/export/excel?page=${currentPage}&size=1000&search=${searchQuery}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReportTransaction();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Transaction History-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setIsOpen(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          let apiUrl = "";
          if (selectedDates.length == 2) {
            apiUrl = `/v1/merchant/dashboard/my-investment/transactions/?page=${currentPage}&size=1000&search=${searchQuery}&start_date=${formatDateForFilter(
              selectedDates[0]
            )}&end_date=${formatDateForFilter(selectedDates[1])}`;
          } else {
            apiUrl = `/v1/merchant/dashboard/my-investment/transactions/?page=${currentPage}&size=1000&search=${searchQuery}`;
          }
          const response = await GetAPIcalls(apiUrl);

          if (response.status == 200) {
            if (response.data == null) {
              setPdfData([]);
              setLoading(false);
              setIsHiddenTable(false);
              showToast("No data available to generate the report.", "error");
            } else {
              setPdfData(response.data.transactions);
              setIsHiddenTable(true);
            }
          } else {
            if (response.status === 401) {
              localStorage.removeItem("jwtToken");
              navigate("/login");
            }
            setPdfData([]);
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [searchQuery, selectedDates] // Dependencies
  );
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  function createTableBody(data, columns) {
    const body = document.createElement("tbody");

    data.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = columns
        .map(({ key, formatter }) => {
          let value = row[key];
          if (formatter) {
            value = formatter(value, row);
          }
          const styleAttr =
            key === "portfolio_name"
              ? 'style="width: 180px; white-space: normal; word-wrap: break-word; word-break: break-word;"'
              : "";

          return `<td >${value !== undefined ? value : ""}</td>`;
        })
        .join("");

      body.appendChild(tr);
    });

    return body;
  }
  const handleDownloadPDF = async () => {
    let headerDashboardFinal = [
      {
        label: "Ref ID",
        key: "ref_code",
      },
      {
        label: "Name",
        key: "name",
        formatter: (val) => "Caprock Model portfolio - " + val,
      },
      {
        label: "Investment manager",
        key: "manager",
        formatter: (val) => val.name,
      },
      {
        label: "Risk Profile",
        key: "risk_rating",
      },
      {
        label: "Strategy Type",
        key: "strategy_type",
      },
      {
        label: "Min Investment Amount",
        key: "minimum_investment",
        formatter: (val) =>
          val
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      {
        label: "Strategy Growth",
        key: "strategy_growth",
        formatter: (val) => val.toFixed(2) + "%",
      },
      {
        label: "Annual Dividend",
        key: "annual_dividend",
        formatter: (val) => val.toFixed(2) + "%",
      },
      {
        label: "Performance",
        key: "performance",
        formatter: (val) => val.toFixed(2) + "%",
      },
      {
        label: "Favourite",
        key: "is_favourite",
        formatter: (val) => (val == true ? "Favourite" : "Un-Favourite"),
      },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(headerDashboardFinal);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody(pdfData, headerDashboardFinal);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
       <style>
                @page {
          size: A4 landscape;
          margin: 0;
        }
          html, body {
                  margin: 0;
                  padding: 0;
                            font-family:sans-serif;
          overflow: auto;  /* Ensure content can overflow */
        
                  height: 100%; /* Ensure the body fills the entire height */
                }        .pdf-container {
                    max-width: 100% !important;
                    margin: 20px;
                  }
                  tr {
                    page-break-inside: avoid !important;
                    break-inside: avoid !important;
                  }
          
                  .custom-header {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding-top: 10px; /* Ensures no padding at the top */
                  }
          
                  .logo-container {
                    display: flex;
                    align-items: center;
                  }
          
                  .logo {
                    width: 96px; /* Tailwind w-24 = 6rem = 96px */
                    max-width: 150px;
                    height: auto;
                    object-fit: contain;
                    margin-right: 1rem;
                  }
          
                  .title {
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 1.125rem; /* Tailwind text-lg */
                    font-weight: 500;    /* Tailwind font-medium */
                    padding: 0;          /* Remove any padding */
                    margin: 0;           /* Remove any margin */
                  }
          
                  .date {
                    font-size: 0.875rem;  /* Tailwind text-sm */
                    font-weight: 500;
                    color: #000000;
                    padding-bottom: 16px;
                  }
        
          
        .page-break {
                 page-break-before: always;
          break-before: page;
          display: block;
          height: 0; /* No extra space */
          width: 100%;
          content: "";}
              table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
            }
        
            thead {
              font-size: 10px;
              color: #6B7280; /* Tailwind text-labelColour equivalent */
            }
        
            th {
              border-bottom: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
                  td {
              padding: 6px;
              font-size: 10px;
              vertical-align: middle;
              text-align: left;
            }
              .tbody-tr{
                          background-color: #F9F9F9;
                          margin-bottom: 10px;
        
              }
                </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">My Investments</h2>
          <div class="date">${date}</div>
        </div>
        
  <table id="dynamic-table">
  ${tableHeader}
    ${tableBody}

  </table>
    
      </div> 

           </body>
    </html>
  `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }

      // For other errors
      const errorData = await response.json().catch(() => ({
        message: "An error occurred",
      }));
      throw new Error(errorData.message || `Error ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `My Investments-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
    setIsOpenReport(false);
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl =
        selected == ""
          ? `${BASE_URL}/v1/merchant/dashboard/my-investment/list/export/excel?sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
          : `${BASE_URL}/v1/merchant/dashboard/my-investment/list/export/excel?risk_rating=${selected}&sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDF = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReport();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `My Investments-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setIsOpenReport(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          const response = await GetAPIcalls(
            selected == ""
              ? `/v1/merchant/dashboard/my-investment/list?sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
              : `/v1/merchant/dashboard/my-investment/list?risk_rating=${selected}&sort_by=${sortkey}&favorite=${selectedFavourite}&limit=1000&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
          );
          if (response.status == 200) {
            if (response.data.data.length > 0) {
              setPdfData(response.data.data);
              setIsHidden(true);
            } else {
              setPdfData([]);
              setIsHidden(false);
              setIsOpenReport(false);
              setLoading(false);
              showToast("No data available to generate the report.", "error");
            }
          }
        } catch (err) {
          if (err.status === 401) {
            localStorage.removeItem("jwtToken");
            navigate("/login");
          }
          setPdfData([]);
          setIsOpenReport(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [selected, sortkey, selectedFavourite, currentPage, searchQuery, sortConfig] // Dependencies
  );
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "10",
  });
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setIsOpen(false);
      }
      if (
        favouriteRef.current &&
        !favouriteRef.current.contains(event.target)
      ) {
        setIsfavouriteOpen(false);
      }
      if (
        DownloadDocRef.current &&
        !DownloadDocRef.current.contains(event.target)
      ) {
        setIsOpenReport(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const [filteredData, setfilteredData] = useState([]);
  const [totalPages, settotalPages] = useState(0);

  const handleSelect = async (option) => {
    setSelected(option.value);
    setIsOpen(false);
  };
  const handleSelectfavourite = async (option) => {
    setSelectedFavourite(option.value);
    setIsfavouriteOpen(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (isOutside) {
        setIsDropdownOpen(null); // Close dropdown if clicked outside
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);
  const handleScroll = () => {
    console.log("In scroll, I am scroll event listener.");

    if (isDropdownOpen !== null) {
      setIsDropdownOpen(null);
    }
  };
  useEffect(() => {
    if (isDropdownOpen !== null) {
      console.log("Dropdown opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log("Dropdown closed, removing scroll event listener.");
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isDropdownOpen]);
  const handleSort = (key) => {
    setSortKey(key);
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key: null, direction });
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const gettableData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        selected == ""
          ? `/v1/merchant/dashboard/my-investment/list?sort_by=${sortkey}&favorite=${selectedFavourite}&limit=${showRecords}&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
          : `/v1/merchant/dashboard/my-investment/list?risk_rating=${selected}&sort_by=${sortkey}&favorite=${selectedFavourite}&limit=${showRecords}&page=${currentPage}&search=${searchQuery}&sort_order=${sortConfig.direction}`
      );
      if (response.status == 200) {
        setTableData(response.data.data);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const postFavouriteAPI = async (rowId) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/investment-hub/toggle-favourite/${rowId}`;
    const bodyData = {};
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmit = useCallback(
    debounce(async (e, rowId) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postFavouriteAPI(rowId);
        if (response.status === 200) {
          toastMessage = { message: response.message, type: "success" };
          gettableData();
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [
      sortkey,
      selectedFavourite,
      selected,
      searchQuery,
      showRecords,
      currentPage,
    ] // Dependencies
  );
  useEffect(() => {
    gettableData();
  }, [
    sortkey,
    selectedFavourite,
    selected,
    searchQuery,
    showRecords,
    currentPage,
    sortConfig,
  ]);
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] pt-0">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="mt-4 flex flex-col md:flex-row md:justify-between md:items-center border-b  gap-y-2 bg-white rounded-md shadow-md py-4 px-2">
        {/* Left-aligned Dropdown */}
        <div className="flex items-center border-colour-custom space-x-2 px-4">
          <h1 className="text-lg font-medium ">
            # Mandate ID:
            <span className="text-[#888888]">
              {" "}
              16c47861-9b81-4009-af5a-538fda3f3c57
            </span>
          </h1>
        </div>

        {/* Right-aligned Info Block */}
        <div className="flex flex-wrap items-center gap-x-2 justify-start md:justify-end w-full md:w-auto">
          <div className="flex flex-col items-start md:items-end">
            <span className="text-sm font-semibold text-[#464646] leading-tight">
              Status
            </span>
          </div>
          <span className="text-md font-semibold">|</span>
          <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
            Active
          </span>
          <span className="text-md font-semibold">|</span>
          <div className="flex flex-col items-start md:items-end">
            <span className="text-sm font-semibold text-[#464646] leading-tight">
              Amount
            </span>
          </div>
          <span className="text-sm font-semibold">|</span>
          <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
            $
            {(10000)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </span>
        </div>
      </div>
      <div className="w-full mt-6 mb-2 p-4 bg-white rounded-lg shadow-lg">
        <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
          <div className="flex items-center">
            <span className="font-medium lg:text-xl text-sm">
              Payment History
            </span>
          </div>
        </div>
        <div className="flex justify-between flex-wrap mb-4 gap-4 mb-4">
          <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
            <div className="flex items-center space-x-2">
              <span className="lg:text-md  text-sm text-[#8C8C8C]">
                Show Records
              </span>
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilter}
                onSelect={handleFilterChange}
              />
            </div>
            <div className="flex items-center">
              <div className="relative">
                <input
                  type="text"
                  className="p-2 pl-8 border rounded-xl w-full"
                  placeholder="Search Name"
                  value={searchQueryStrategies}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchQuery(e.target.value);
                  }}
                />
                <span className="absolute left-2 top-3 text-gray-500">
                  {" "}
                  <img
                    src="/search-normal.svg"
                    alt="Company Logo"
                    className="mr-2"
                  />
                </span>
              </div>
            </div>
          </div>

          <div className="flex justify-end flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-2">
            <div ref={DateCalendarRef} className="flex items-center space-x-4">
              <div className="relative w-full">
                {/* Dropdown Trigger */}
                <div
                  className="flex items-center justify-between p-2 w-60 md:w-60 border rounded-xl bg-white cursor-pointer"
                  onClick={toggleDropdown}
                >
                  <span>{selectedRange}</span>
                  <img
                    src="/download-small-arrow.svg"
                    alt="Dropdown"
                    className="w-2 h-2"
                  />
                </div>

                {/* Dropdown */}
                {isDropdownOpen && (
                  <div className="absolute top-12  md:left-1/4 left-0 transform md:-translate-x-1/2  mt-2 bg-white border rounded-lg shadow-lg z-10 w-[90vw] md:w-[900px] max-h-[400px] overflow-auto">
                    <div className="flex  flex-col md:flex-row h-full">
                      {/* Left: Quick Filters */}
                      <div className="w-full md:w-1/3 border-r p-3 h-full">
                        {quickFilters.map((filter) => (
                          <div
                            key={filter.value}
                            className={`p-2 cursor-pointer rounded ${
                              quickFilter === filter.value
                                ? "bg-black text-white"
                                : "hover:bg-gray-200 text-black"
                            } transition-all duration-200 ease-in-out`}
                            onClick={() => handleQuickFilter(filter.value)}
                          >
                            {filter.label}
                          </div>
                        ))}
                      </div>

                      {/* Right: Calendar */}
                      <div className="w-full md:w-2/3 overflow-auto p-3 h-full">
                        <Flatpickr
                          key={selectedDates}
                          options={{
                            mode: "range",
                            inline: true,
                            dateFormat: "Y-m-d",
                            showMonths: 2,
                            defaultDate:
                              selectedDates.length > 0 ? selectedDates : [],
                            shorthandCurrentMonth: true,
                            locale: {
                              firstDayOfWeek: 1, // Sets Monday as the first day of the week
                            },
                            onChange: (dates) => {
                              if (
                                quickFilter === "custom" &&
                                dates.length === 2
                              ) {
                                setSelectedDates(dates);
                              }
                            },
                          }}
                          className="w-full"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div ref={DownloadRef} className="flex items-center space-x-4">
              <div className="relative inline-block ">
                <div
                  className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                  onClick={() => setIsOpen(!isOpen)}
                >
                  <img
                    src="/document-download.svg"
                    alt="document-download"
                    className="mr-2"
                  />
                  <span>Download Report</span>
                  <span className="text-gray-500">
                    {" "}
                    <img
                      src="/download-small-arrow.svg"
                      alt="Dropdown"
                      className="w-2 h-2"
                    />
                  </span>
                </div>
                {isOpen && (
                  <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                    {options.map((option) => (
                      <li
                        key={option.value}
                        className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                        onClick={(e) => {
                          e.preventDefault();
                          setLoading(true);
                          downloadPDFTable(e, option);
                        }}
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto mt-4">
          <table className="table-auto border-collapse font-medium w-full text-xs">
            <thead>
              <tr className="bg-[#ECFFEE] text-[#005A9C]">
                <th className="border  text-left px-4 py-2">Date</th>
                <th className="border text-left px-4 py-2">Amount</th>
                <th className="border text-left px-4 py-2">Status</th>
                <th className="border text-left px-4 py-2">Reference Number</th>
              </tr>
            </thead>
            {isLoadingHistory ? (
              <tbody className="shimmer-container-list ">
                {/* Creating 5 rows of shimmer effect */}
                {[...Array(5)].map((_, rowIndex) => (
                  <tr key={rowIndex} className="shimmer-row-list">
                    {/* Creating 7 cells in each row for shimmer */}
                    {[...Array(5)].map((_, colIndex) => (
                      <td key={colIndex} className="shimmer-cell-list">
                        <div className="shimmer-loader"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                {transactionHistoryData.length > 0 ? (
                  transactionHistoryData.map((row, index) => (
                    <tr key={row.id} className="text-black">
                      <td className="border px-4 py-2">
                        {formatDateList(row.created_at)}
                      </td>
                      <td className="border px-4 py-2">
                        $
                        {row.amount
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>
                      <td className="border px-4 py-2">{row.status}</td>
                      <td className="border px-4 py-2">{row.stock_status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center py-4" colSpan="7">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
        </div>

        {transactionHistoryData != null && (
          <div className="flex flex-wrap justify-between items-center mt-6 mb-4 space-y-4 sm:space-y-0">
            <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
              Showing {showRecords * (currentPage - 1) + 1} to{" "}
              {currentPage === totalPages || totalPages == 0
                ? totalCount
                : Math.max(
                    showRecords * currentPage,
                    transactionHistoryData.length
                  )}{" "}
              of {totalCount} entries
            </div>

            <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Prev
              </button>
              {Array.from({ length: Math.min(totalPages, 5) }).map(
                (_, index) => {
                  const startPage = Math.max(
                    1,
                    Math.min(totalPages - 4, currentPage - 2)
                  );
                  const page = startPage + index;

                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-3 py-1 rounded ${
                        currentPage === page
                          ? "bg-black text-white"
                          : "bg-white border border-gray-300 text-black"
                      }`}
                    >
                      {page}
                    </button>
                  );
                }
              )}
              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MandateDetails;
